export default __webpack_public_path__ + "static/media/fi2015.83cc9aca.pdf";